import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import classNames from 'classnames';

import { CardSection } from 'components/Card';
import Message from 'components/Message';
import LoadingDots from 'components/LoadingDots';
import When from 'components/When';

import { bem } from 'helpers/class-name';
import { PFE_ICONS } from 'constants/icons';

import { messages } from './MFASetupModal.messages';

const { element } = bem('mfa-setup-modal');

const OTP_CODE_LENGTH = 6;

const EnterCodeStep = ({ isValidatingOTP, hasError, onGoBack, onOTPCodeEnter, onClearError }) => {
  const [OTPCode, setOTPCode] = useState('');

  const inputRef = useRef(null);

  useEffect(() => {
    if (hasError) setOTPCode('');
  }, [hasError]);

  const handleOTPCodeChange = e => {
    const rawValue = e.target.value.trim();
    if (!/^\d*$/.test(rawValue)) return;

    setOTPCode(rawValue);

    if (rawValue.length === OTP_CODE_LENGTH) {
      onOTPCodeEnter(rawValue);
    }
  };

  return (
    <CardSection className={element('enter-code-wrapper')} flush>
      <Message as="p" className={element('enter-code-label')} message={messages.enterCodeLabel} />
      <div>
        <input
          type="text"
          className={classNames(
            element('code-input'),
            isValidatingOTP ? element('code-input--loading') : '',
            hasError ? element('code-input--error') : ''
          )}
          maxLength={6}
          value={OTPCode}
          name="OTPCode"
          disabled={isValidatingOTP}
          placeholder="______"
          ref={inputRef}
          onChange={handleOTPCodeChange}
          onFocus={() => {
            if (hasError) onClearError();
          }}
        />
        <When predicate={hasError}>
          <Message className={element('otp-error-label')} message={messages.codeNotValid} role="alert" />
        </When>
      </div>
      <div className={element('enter-code-footer')}>
        <button
          className={element('back-btn')}
          onClick={() => {
            if (hasError) onClearError();
            onGoBack();
          }}
          disabled={isValidatingOTP}
          type="button">
          <Isvg src={PFE_ICONS.chevronRight} aria-hidden="true" />
          Back
        </button>
        <When predicate={isValidatingOTP}>
          <LoadingDots />
        </When>
      </div>
    </CardSection>
  );
};

EnterCodeStep.propTypes = {
  isValidatingOTP: PropTypes.bool,
  hasError: PropTypes.bool,
  onGoBack: PropTypes.func.isRequired,
  onOTPCodeEnter: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
};

export default EnterCodeStep;
